import React from "react";
import { Text } from "@chakra-ui/react";
import { Modal } from "newui/components/ui/Modal";
import {
	CONFIRM_DECISION_BODY,
	CONFIRM_DECISION_TITLE,
} from "../awardDecisions";

interface ConfirmDecisionDialogProps {
	isOpen: boolean;
	isSubmitting: boolean;
	confirmLabel?: string;
	body?: string;
	onCancel: () => void;
	onConfirm: () => void;
}

/**
 * "Decisions are final" confirmation gate shown before any award / not-awarded
 * mutation is dispatched. The confirm button is disabled (and shows a loading
 * state) while the mutation is in flight so the action cannot be double-fired.
 */
export const ConfirmDecisionDialog: React.FC<ConfirmDecisionDialogProps> = ({
	isOpen,
	isSubmitting,
	confirmLabel = "Confirm",
	body = CONFIRM_DECISION_BODY,
	onCancel,
	onConfirm,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onCancel}
			title={CONFIRM_DECISION_TITLE}
			iconType="warning"
			closeOnOverlayClick={!isSubmitting}
			closeOnEsc={!isSubmitting}
			primaryButton={{
				text: confirmLabel,
				onClick: onConfirm,
				isLoading: isSubmitting,
				disabled: isSubmitting,
			}}
			secondaryButton={{
				text: "Cancel",
				onClick: onCancel,
				disabled: isSubmitting,
			}}
		>
			<Text data-testid="confirm-decision-body">{body}</Text>
		</Modal>
	);
};
